import React, { useEffect, useState } from 'react';
import UserProducts from './UserProducts';

interface User {
    id: string;
    steam_id: string;
    avatar_url: string;
    profile_url: string;
    nickname: string;
    registration_date: string;
}

const Profile: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/me`, { credentials: 'include' })
            .then((response) => {
                if (response.status === 401) {
                    throw new Error('Not authenticated');
                }
                return response.json();
            })
            .then((data) => {
                setUser(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching profile:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="min-h-[calc(100vh-130px)] flex items-center justify-center bg-gray-900 text-white">
                <div className="w-24 h-24 border-8 border-t-sky-800 border-slate-400 rounded-full animate-spin"></div>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="min-h-[calc(100vh-130px)] flex items-center justify-center bg-gray-900 text-white text-xl font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                User not found or not authenticated
            </div>
        );
    }

    return (
        <div className="min-h-[calc(100vh-130px)] bg-gray-900 text-white flex flex-col items-center">
            <main className="flex flex-col items-center w-4/5 p-8">
                <div className="bg-gradient-to-r from-slate-800 to-gray-800 p-6 rounded-lg shadow-xl w-full flex items-stretch mb-4 justify-center gap-4 text-slate-300 font-medium text-sm"
                style={{ fontFamily: 'Montserrat, serif' }}>
                    <a href={user.profile_url} target="_blank" rel="noopener noreferrer">
                        <img src={user.avatar_url} alt={user.nickname} className="w-32 h-32 rounded-md" />
                    </a>
                    <div>
                        <h3 className="text-3xl text-white font-bold" style={{ fontFamily: 'Tektur, serif'}}>{user.nickname}</h3>
                        <p>Customer ID: {user.id}</p>
                        <p>Steam ID: {user.steam_id}</p>
                        <p>Join Date: {new Date(user.registration_date).toLocaleDateString()}</p>
                    </div>
                </div>  

                <div className="bg-gradient-to-r from-slate-800 to-gray-800 p-6 rounded-lg shadow-xl w-full flex flex-col items-center justify-center gap-4 text-slate-300 font-medium text-sm">
                <UserProducts />
                </div>
            </main>
        </div>
    );
};

export default Profile;